import React, { useState } from 'react'
import { MDBContainer, MDBRow, MDBCol,
    MDBView, MDBMask, MDBBtn,MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import { Link } from 'react-router-dom'
import img from '../img/menulink.jpg'
import img2 from '../img/menulink2.jpg'
import img3 from '../img/menulink3.jpg'
import Lottie from 'lottie-react-web';
import pageConstruction from '../img/page-construction.json'

const MenuLinks = () => {
    const [show, setShow] = useState(false);
    return (
        <>
            <MDBContainer fluid className="mt-5 mb-5 p-4">
                <MDBRow>
                    <MDBCol onClick={()=>setShow(!show)} className="menu-link-item" sm="12" lg="4" md="4">
                        <MDBView waves zoom>
                            <img
                            src={img}
                            className="img-fluid"
                            alt=""
                            />
                            <MDBMask overlay="black-strong" className="flex-center">
                                <MDBBtn size="lg" outline color="white">
                                    <strong className="white-text text-uppercase">shop</strong>
                                </MDBBtn>
                            </MDBMask>
                        </MDBView>
                    </MDBCol>
                    <MDBCol className="menu-link-item" sm="12" lg="4" md="4">
                        <MDBView zoom>
                            <img
                            src={img2}
                            className="img-fluid"
                            alt=""
                            />
                            <MDBMask overlay="black-strong" className="flex-center">
                                <Link to="/blogs">
                                    <MDBBtn size="lg" outline color="white">
                                        <strong className="white-text text-uppercase">blog</strong>
                                    </MDBBtn>
                                </Link>
                            </MDBMask>
                        </MDBView>
                    </MDBCol>
                    <MDBCol className="menu-link-item" sm="12" lg="4" md="4">
                        <MDBView zoom>
                            <img
                            src={img3}
                            className="img-fluid"
                            alt=""
                            />
                            <MDBMask overlay="black-strong" className="flex-center">
                                <Link to="/about">
                                    <MDBBtn outline size="lg" color="white">
                                        <strong className="white-text text-uppercase">about</strong>
                                    </MDBBtn>
                                </Link>
                            </MDBMask>
                        </MDBView>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
            <MDBModal isOpen={show} centered>
                <MDBModalHeader toggle={()=>setShow(!show)} style={{ border: 0 }}/>
                <MDBModalBody>
                <div className="p-5">
                    <div className="text-center">
                    <div>
                        <Lottie
                        options={{
                            animationData: pageConstruction
                        }}
                        />
                    </div>
                    <div className="mt-4">
                        <p className="font-weight-bold">
                        We'll be leaving the Blog part of Minimuni, we'll now go to the E-Commerce part of Minimuni.
                        </p>
                    </div>
                    <div>
                        <a href="https://theminimuni.com/pages/shop.html" className="newsletter-subscription-button z-depth-1">I understand</a>
                    </div>
                    </div>
                </div>
                </MDBModalBody>
            </MDBModal> 
        </>
    )
}

export default MenuLinks
